// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { OrderDetailsShipmentDetailsInfoStyles } from "@electrowire/App/Components/OrderDetails/OrderDetailsShipmentInfoDetails";
import { screen } from "@gcg/XDL/Helpers";
import { printStyles } from "@gcg/XDL/Utilities";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

OrderDetailsShipmentDetailsInfoStyles.tableRowStyle = {
    evenRowCss: css`
        &&& {
            background: transparent;
        }
    `,
    css: css`
        background: transparent;
        border-color: ${getColor("common.ui4")};
        &&&:hover,
        &&&:focus {
            background: transparent;
            cursor: unset;
        }
        @media print {
            &&& {
                border: 0;
                display: flex;
                flex-direction: column;
            }
        }
        ${screen("lte", "md")`
            display: flex;
            flex-direction: column;
            padding: 20px 0;
            border-top-width: 1px;
            border-top-style: solid;
            td {
                height: 100%;
                padding: 6px 0;
            }
         `}
    `,
};
OrderDetailsShipmentDetailsInfoStyles.tableHeaderStyle = {
    typographyProps: {
        size: 12,
        weight: 500,
        css: css`
            text-transform: none;
        `,
    },
    css: css`
        border-color: ${getColor("common.ui4")};
        padding: 10px;
        &&&:focus,
        &&&:hover {
            background: transparent;
            cursor: unset;
        }
        ${screen("lte", "md")`
        display: inline-flex;
        width: 100%;
            @media not print {
                ${TypographyStyle} {
                    display: none;
                }
            }
            @media print {                    
                &&& {                    
                    -webkit-print-color-adjust: exact;
                }   
            }
        `}
    `,
};
OrderDetailsShipmentDetailsInfoStyles.tableCellStyle = {
    css: css`
        height: 40px;
        padding: 10px;
        vertical-align: top;
        border-bottom: 0;

        ${screen("lte", "md")`
                 display: flex;
                 align-items: center;
                &.hide-on-mobile {
                    display:none;
                }
            `}
    `,
};
OrderDetailsShipmentDetailsInfoStyles.orderLineCardImage = {
    css: css`
        max-width: 70px;
    `,
};
OrderDetailsShipmentDetailsInfoStyles.shippingDetailsTableHeaderStyle = {
    css: css`
        background-color: ${getColor("common.ui2")};
        &&&:focus,
        &&&:hover {
            background: transparent;
            cursor: initial;
        }
        ${screen("lte", "md")`
            display: none;
        `}
    `,
};

OrderDetailsShipmentDetailsInfoStyles.tableCellGridStyle = {
    width: [6, 6, 6, 12, 12],
    css: css`
        word-break: keep-all;
        white-space: break-spaces;
        font-size: 12px;
        &&& {
            max-width: 100%;
            padding: 0;
        }
        @media print {
            max-width: 100%;
            flex-basis: 100%;
        }
    `,
};

OrderDetailsShipmentDetailsInfoStyles.hiddenHeaderStyle = {
    above: "md",
    css: css`
        min-width: 33%;
        font-weight: bold;
        ${printStyles.hideOnPrint}
        ${screen("lt", "sm")`
            min-width: 50%;
        `}
    `,
};
